import { ITableInfinite } from 'components/table/infinite/InfiniteTable.interfaces'
import { EEinvoicingStatus, TInvoiceEinvoiceLink, TInvoiceEinvoiceLinkEnriched } from '@Arti-zen/package-backoffice'
import { Link } from 'react-router-dom'
import { pages } from 'navigation/pages'
import { DateTime } from 'luxon'

export const colorByState: { [key in EEinvoicingStatus]: string } = {
  [EEinvoicingStatus.TEST_PENDING]: 'blue',
  [EEinvoicingStatus.TEST_SUCCESS]: 'green',
  [EEinvoicingStatus.TEST_COMPANY_NOT_READY]: 'orange',
  [EEinvoicingStatus.TEST_FAILED]: 'red',
  [EEinvoicingStatus.UPLOAD_IN_PROGRESS]: 'green',
  [EEinvoicingStatus.UPLOAD_SUCCEEDED]: 'green',
  [EEinvoicingStatus.UPLOAD_FAILED]: 'green',
  [EEinvoicingStatus.SENT]: 'green',
  [EEinvoicingStatus.RECEIVED]: 'green',
  [EEinvoicingStatus.REJECTED_IN_PROGRESS]: 'green',
  [EEinvoicingStatus.REJECTED]: 'green',
  [EEinvoicingStatus.ACKNOWLEDGED]: 'green',
  [EEinvoicingStatus.ACCEPTED_IN_PROGRESS]: '',
  [EEinvoicingStatus.ACCEPTED]: 'green',
  [EEinvoicingStatus.INADMISSIBLE]: 'red'
}

export const definitionFields = ({
  onSelect,
}: {
  onSelect: (item: TInvoiceEinvoiceLinkEnriched) => void
}): ITableInfinite<TInvoiceEinvoiceLinkEnriched>['definitionFields'] => {
  return [
    {
      indexName: 'invoiceId',
      label: 'FactureId',
      format: ({ invoiceId }) => (
        <Link to={pages.connected.invoice.root.navigate(invoiceId)} target="_blank">
          {invoiceId}
        </Link>
      ),
    },
    {
      indexName: 'userId',
      label: 'UserId',
      format: ({ userId }) => (
        <Link to={pages.connected.artisan.profile.navigate(userId)} target="_blank">
          {userId}
        </Link>
      ),
    },
    {
      indexName: 'userEmail',
      label: 'UserEmail',
      format: ({ userId, userEmail }) => (
        <Link to={pages.connected.artisan.profile.navigate(userId)} target="_blank">
          {userEmail}
        </Link>
      ),
    },
    {
      indexName: 'state',
      label: 'Etat',
      format: ({ state }) => <div style={{ backgroundColor: colorByState[state] }}>{state}</div>,
    },
    {
      indexName: 'error',
      label: 'erreur',
      onClick: (item) => !!item.error && onSelect(item),
    },
    {
      indexName: 'createdAt',
      label: 'Date de création',
      format: ({ createdAt }) => {
        const date = new Date(createdAt)
        return DateTime.fromJSDate(date).toFormat('dd/MM/yyyy - HH:mm:ss')
      },
    }
  ]
}

export const firstColumn: ITableInfinite<TInvoiceEinvoiceLink>['firstColumn'] = {
  format: () => <></>,
}
